import { createSlice } from '@reduxjs/toolkit';

const positionSlice = createSlice({
  name: 'position',
  initialState: {},
  reducers: {
    addPosition: (state, action) => {
      const { pathname, scrollTo } = action.payload;

      state = {
        ...state,
        [pathname]: {
          pathname,
          scrollTo,
        },
      };
      return state;
    },
    resetPosition: (state, action) => {
      const { pathname } = action.payload;

      state = {
        ...state,
        [pathname]: {
          pathname,
          scrollTo: 0,
        },
      };
      return state;
    },
  },
});

export const { addPosition, resetPosition, resetAllPositions } =
  positionSlice.actions;

export default positionSlice.reducer;
